module.exports = __webpack_public_path__ + "img/the-505.6a8b3cf8.png";